import * as React from 'react';
import './TeamTestInvitationPopup.css';
import { AppStore } from '../../../../stores';
import { inject, observer } from 'mobx-react';
import GroupService from '../../../../services/GroupService';
import { IGroup } from '../../../../interfaces/IGroup';
import Group from '../group/Group';
import { IMyGroup } from '../../../../interfaces/IMyGroup';

export interface IProps {
  appStore?: AppStore;
  id?: string;
  onClose: () => void;
}

export interface IState {
  loadingGroups: boolean;
}

@inject('appStore')
@observer
export default class TeamTestInvitationPopup extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      loadingGroups: false
    };
  }

  public componentDidMount(): void {
    if (this.props.id) {
      this.getMyGroups();
    }
  }

  private async getMyGroups(): Promise<void> {
    if (this.props.appStore?.user?.id) {
      const myGroups = [];
      this.setState({ loadingGroups: true });
      await GroupService.getGroupsForUser(this.props.appStore?.user?.username).then((groups: IGroup[]) => {
        if (groups?.length > 0) {
          this.props.appStore!.groups = groups;
          this.props.appStore!.groups?.forEach((group: IGroup) => {
            GroupService.getMyGroupMemberInfoForGroup(group.objectId, this.props.appStore?.user?.id).then((groupMemberInfo: any,) => {
              myGroups.push({
                group,
                groupMemberInfo: groupMemberInfo?.results?.length > 0 ? groupMemberInfo?.results[0] : undefined
              });
              this.props.appStore!.myGroups = myGroups;
              this.setState({ loadingGroups: false });
            });
          });
        } else {
          this.setState({ loadingGroups: false });
        }
      });
    }
  }

  render() {
    return (
      <div className="teamTestInvitationPopup">
        <div
          className="teamTestInvitationPopupBackground"
          onClick={() => {
            this.props.onClose();
          }}
        />
        <div className="teamTestInvitationPopupBox">
          {this.state.loadingGroups ? (
            <div className="loader" />
          ) : (
            <>
              {this.props.appStore!.myGroups.find((myGroup: IMyGroup) => myGroup.group.objectId === this.props.id) ? (
                <>
                  <Group
                    key={this.props.appStore!.myGroups.find((myGroup: IMyGroup) => myGroup.group.objectId === this.props.id)?.group.objectId}
                    style={{
                      width: this.props.appStore!.isMobile ? '100%' : '420px',
                    }}
                    group={this.props.appStore!.myGroups.find((myGroup: IMyGroup) => myGroup.group.objectId === this.props.id)}
                    getMyGroups={() => { }} //this.getMyGroups()}
                  />
                  <div
                    className='closeButton'
                    onClick={() => {
                      this.props.onClose();
                    }}
                  />
                </>
              ) : (
                <div className='noAccess'>
                  Du har ikke adgang til denne gruppe.
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }

}